// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o8ZM","toggle":"styles_toggle__2DKtw","preview":"styles_preview__8LJJh"};